export default __webpack_public_path__ + "static/media/icon_link.e583c5b4.svg";